module.exports = __webpack_public_path__ + "22d8e571a9914a9e1d48b0958cf83eec.png";